import type { SVGProps } from '@/types/common.types';

const SubscriptionWinkSVG = (props: SVGProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="81"
      height="26"
      viewBox="0 0 81 26"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_14572_12775)">
        <path
          d="M24.2109 4.00537H27.5783L30.2675 14.7144C30.2675 14.7144 30.5591 15.9499 30.68 16.5569C30.801 15.9522 31.0927 14.6907 31.0927 14.6907L33.8553 4.00537H37.1514L39.9141 14.6907C39.9141 14.6907 40.2058 15.9499 40.3267 16.5569C40.4477 15.9522 40.7393 14.7144 40.7393 14.7144L43.4285 4.00537H46.7957L42.1195 20.9653H38.6786L35.5057 8.65796L32.3329 20.9653H28.8921L24.2109 4.00537Z"
          fill="white"
        />
        <path d="M51.7941 8.94739H48.7422V20.9654H51.7941V8.94739Z" fill="white" />
        <path
          d="M63.1449 20.9655V14.0364C63.1449 12.4618 62.3932 11.4683 60.6977 11.4683C59.0993 11.4683 57.9113 12.8484 57.9113 14.8593V20.9655H54.8594V8.9475H57.9113V10.8849C58.8077 9.50481 60.2377 8.6084 61.9806 8.6084C64.5487 8.6084 66.1968 10.2802 66.1968 12.7749V20.9631H63.1449V20.9655Z"
          fill="white"
        />
        <path
          d="M68.9375 4.00537H71.9894V12.5825L75.6485 8.94727H79.4284L75.0438 13.2347L80.0117 20.9629H76.4974L72.912 15.3428L71.9918 16.2391V20.9629H68.9399V4.00537H68.9375Z"
          fill="white"
        />
        <path
          d="M48.3359 2.76515L49.5287 3.95794L48.3359 5.15073L49.7469 6.55932L52.3482 3.95794L49.7469 1.35657L48.3359 2.76515Z"
          fill="white"
        />
        <path
          d="M6.81289 0L0 6.81289L5.76475 12.5777L0 18.3448L6.81289 25.1577L19.3929 12.5777L6.81289 0Z"
          fill="#FF3F2A"
        />
      </g>
      <defs>
        <clipPath id="clip0_14572_12775">
          <rect width="80.7857" height="26" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SubscriptionWinkSVG;
